import { AdjacentType } from '@iotv/iotv-v3-types';
import { BranchingQueryDefinition } from '@iotv/datamodel-core';
const apexPath = [
    {
        adjacencyType: AdjacentType.SUBJECT,
        objectTypeId: 'Property',
    },
];
const contextObjectToProperty = [{ objectTypeId: 'Property', adjacencyType: AdjacentType.CHILD }];
const contextObjectToField = [{ objectTypeId: 'Field', adjacencyType: AdjacentType.CHILD }];
const contextObjectToArea = [{ objectTypeId: 'Area', adjacencyType: AdjacentType.CHILD }];
const contextObjectToPlace = [{ objectTypeId: 'Place', adjacencyType: AdjacentType.CHILD }];
/** where property is the context defining object  */
const propertyApexQuery = new BranchingQueryDefinition({
    id: 'apexPath',
    path: apexPath,
    subQueries: [],
});
const propertyToAreaQuery = new BranchingQueryDefinition({
    id: 'propertyToAreaQuery',
    path: contextObjectToArea,
    subQueries: [],
});
const propertyToPlaceQuery = new BranchingQueryDefinition({
    id: 'propertyToPlaceQuery',
    path: contextObjectToPlace,
    subQueries: [],
});
const fieldToFieldQuery = new BranchingQueryDefinition({
    id: 'fieldToFieldQuery',
    path: contextObjectToField,
    subQueries: [],
});
const fieldToPlaceQuery = new BranchingQueryDefinition({
    id: 'fieldToPlaceQuery',
    path: contextObjectToField,
    subQueries: [],
});
const propertyToFieldQuery = new BranchingQueryDefinition({
    id: 'propertyToFieldQuery',
    path: contextObjectToField,
    subQueries: [],
});
const areaToPlaceQuery = new BranchingQueryDefinition({
    id: 'areaToPlaceQuery',
    path: contextObjectToField,
    subQueries: [],
});
const areaToAreaQuery = new BranchingQueryDefinition({
    id: 'areaToAreaQuery',
    path: contextObjectToArea,
    subQueries: [],
});
propertyApexQuery.addSubQuery(propertyToAreaQuery);
propertyApexQuery.addSubQuery(propertyToPlaceQuery);
propertyToAreaQuery.addSubQuery(areaToAreaQuery);
areaToAreaQuery.addSubQuery(areaToAreaQuery);
areaToAreaQuery.addSubQuery(areaToPlaceQuery);
propertyApexQuery.addSubQuery(propertyToFieldQuery);
propertyApexQuery.addSubQuery(fieldToFieldQuery);
fieldToFieldQuery.addSubQuery(fieldToPlaceQuery);
export { propertyApexQuery as PropertyAreaPlaceQuery };
